module.exports = __webpack_public_path__ + "img/9_financial-wellness.684ba881.png";